import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Analytics } from "@/components/Analytics";
import { UpdatePopup } from "@/components/UpdatePopup";
import { TaxAssistant } from "@/components/TaxAssistant";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import TaxUpdates from "@/pages/TaxUpdates";
import AccountingSoftware from "@/pages/AccountingSoftware";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => {
          if (lenis) lenis.scrollTo(el, { offset: -90 });
          else el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
        return;
      }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollManager />
      <Analytics />
      {!isAdmin && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/tax-updates" element={<TaxUpdates />} />
          <Route path="/accounting-software" element={<AccountingSoftware />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
      {!isAdmin && <TaxAssistant />}
      {!isAdmin && <UpdatePopup />}
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <SmoothScroll>
          <Shell />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
